// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Components
import { Grid } from 'HTKit/Grid';
import Form from './Form';
// Constants
// eslint-disable-next-line import/order
import { DEFAULT_LAYOUT } from 'src/constants/common';
import { PAGE_NAME } from './constants';
// Styles
import styles from './styles.scss';

const GetOrderStatusPage = ({
  loadPage,
  layoutUpdate,
  pageErrors,
  submitForm,
  title,
  validateForm,
}) => {
  useEffect(() => {
    loadPage(PAGE_NAME);
    layoutUpdate(DEFAULT_LAYOUT);
  }, []);
  return (
    <Grid.Fluid classes={cn('site-v2', styles.container)}>
      <Grid.Row>
        <Grid.Column sm={4} mdOffset={1} md={6} lgOffset={4} lg={4}>
          <h4 className={styles.title}>{title}</h4>
          <Form validateForm={validateForm} pageErrors={pageErrors} submitForm={submitForm} />
        </Grid.Column>
      </Grid.Row>
    </Grid.Fluid>
  );
};

GetOrderStatusPage.propTypes = {
  layoutUpdate: PropTypes.func.isRequired,
  loadPage: PropTypes.func.isRequired,
  pageErrors: PropTypes.object,
  submitForm: PropTypes.func,
  title: PropTypes.string,
  validateForm: PropTypes.func,
};

GetOrderStatusPage.defaultProps = {
  layoutUpdate: () => {},
  loadPage: () => {},
  pageErrors: {},
  submitForm: () => {},
  title: 'Track your order',
  validateForm: () => {},
};

export default React.memo(GetOrderStatusPage);
